import React, { useEffect } from 'react';
import appData from '../data/data';

export default function About() {
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) entry.target.classList.add('visible');
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.fade-in').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div>

      {/* Top Section */}
      <section className="section" style={{ paddingTop: '8rem' }}>
        <h1 className="section-title fade-in">About Syntax2Scale</h1>

        <p className="section-subtitle fade-in">
          We combine technical excellence with business acumen to deliver results.
        </p>

        <div className="card-grid fade-in">
          <div className="card">
            <h3>Our Mission</h3>
            <p>
              To empower businesses with innovative solutions that drive growth, efficiency, and success.
              We are committed to delivering excellence in every project, building lasting partnerships,
              and creating value that extends beyond technology.
            </p>
          </div>
        </div>

        {/* ⭐ Added Image Section (matches original design) */}
        <img
          src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1000&h=600&fit=crop"
          alt="Team collaboration"
          className="about-image fade-in"
          style={{
            width: '100%',
            maxWidth: '1000px',
            margin: '2.5rem auto 0',
            display: 'block',
            borderRadius: '16px'
          }}
        />
      </section>

      {/* Core Values Section */}
      <section className="section">
        <h2 className="section-title fade-in">Our Core Values</h2>

        <div className="values-grid">
          {appData.values.map((v, idx) => (
            <div
              key={idx}
              className="value-card fade-in"
              style={{ animationDelay: `${idx * 0.1}s` }}
            >
              <div className="value-icon">
                <v.Icon />
              </div>

              <h3 className="value-title">{v.title}</h3>
              <p className="card-description">{v.description}</p>
            </div>
          ))}
        </div>
      </section>

    </div>
  );
}
